import { NextImage } from "@jog/react-components"
import React from "react"

function LogoLoaderFC() {
    return (
        <div className="fixed inset-0 z-10 flex items-center justify-center bg-black/70">
            <NextImage
                unoptimized
                blur={false}
                className="logo"
                src="/images/jc-loader.gif"
                width={102}
                height={74}
                alt="loader"
            />
        </div>
    )
}
export const LogoLoader = React.memo(LogoLoaderFC)
